import { styled, TableContainer } from '@mui/material';
import './converge-accordion.scss';
import { ReactNode } from 'react';

export const StyledTableContainer = styled(TableContainer)(() => ({
  border: '1px solid #E7E7E7',
  borderRadius: '4px',
}));

interface IProps {
  children: ReactNode;
}

export const CustomTableContainer = ({ children }: IProps) => {
  return <StyledTableContainer>{children}</StyledTableContainer>;
};
